module.exports = __webpack_public_path__ + "assets/images/05B-route-sheet.png";


//////////////////
// WEBPACK FOOTER
// ./client/app/assets/images/05B-route-sheet.png
// module id = 1259
// module chunks = 1